<template
  ><div>
    <section class="m-nav_main">
      <section class="navigation">
        <article class="m-padding m-menu-icon">
          <router-link to="/" class="logo">
            <img
              src="@/assets/source/images/m_logo_happytable.svg"
              alt="로고"
            />
          </router-link>
          <div class="menu_icon" @click="naviIsOpen">
            <img src="@/assets/source/images/m_ic_menu.svg" alt="메뉴버튼" />
          </div>
        </article>
        <article class="drop-down">
          <div class="m-padding main-list" v-if="naviIsOpenToClose">
            <div class="sns-icon-close">
              <div class="icon">
                <div class="instagram-icon">
                  <a
                    href="https://www.instagram.com/happytable_official/"
                    target="_blank"
                  >
                    <img
                      src="@/assets/source/images/m_ic_sns_insta.svg"
                      alt="go to instagram"
                    />
                  </a>
                </div>
                <div class="facebook-icon">
                  <a
                    href="https://www.facebook.com/happytable2020/?ref=bookmarks"
                    target="_blank"
                  >
                    <img
                      src="@/assets/source/images/m_ic_sns_facebook.svg"
                      alt="go to instagram"
                    />
                  </a>
                </div>

                <div class="kakao-icon">
                  <a href="http://pf.kakao.com/_xjYRxab" target="_blank">
                    <img
                      src="@/assets/source/images/m_ic_sns_kakao.svg"
                      alt="go to kakao"
                    />
                  </a>
                </div>
              </div>
              <div class="close" @click="naviIsOpenToClose = false">
                <img src="@/assets/source/images/m_ic_close.svg" alt="닫기" />
              </div>
            </div>
            <ul class="main-list__title">
              <li class="item">
                <div
                  class="main-menu"
                  @click="dropdownIsOpenClose('happytable')"
                >
                  <router-link
                    to="/happytable"
                    :class="{menuActive: isActive('happytable')}"
                  >
                    <span class="tab-title">해피테이블</span>
                  </router-link>
                  <div
                    class="arrow"
                    :class="{
                      ['arrowOpen']:
                        isOpenSubMenu && activeMenu == 'happytable',
                    }"
                  >
                    <span>&gt;</span>
                  </div>
                </div>

                <ul
                  class="m-sub-menu"
                  v-if="isOpenSubMenu && activeMenu == 'happytable'"
                >
                  <li class="sub-menu-title">
                    <router-link to="/happytable">
                      <span class="title">브랜드 이야기</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/happytable/award">
                      <span>인증 / 수상</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/happytable/update">
                      <span>버전 3.5</span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="item">
                <div class="main-menu" @click="dropdownIsOpenClose('product')">
                  <router-link
                    to="/productinfo"
                    :class="{menuActive: isActive('product')}"
                  >
                    <span class="tab-title">제품 소개</span>
                  </router-link>
                  <div
                    class="arrow"
                    :class="{
                      ['arrowOpen']: isOpenSubMenu && activeMenu == 'product',
                    }"
                  >
                    <span>&gt;</span>
                  </div>
                </div>

                <ul
                  class="m-sub-menu"
                  v-if="isOpenSubMenu && activeMenu == 'product'"
                >
                  <li class="sub-menu-title">
                    <router-link to="/productinfo">
                      <span>43 인치</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/productinfo/32inch">
                      <span>32 인치</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/productinfo/happytablet">
                      <span>해피태블릿</span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="item">
                <div
                  class="main-menu"
                  @click="dropdownIsOpenClose('cognition')"
                >
                  <router-link
                    to="/cognition"
                    :class="{menuActive: isActive('cognition')}"
                  >
                    <span class="tab-title">게임 소개</span>
                  </router-link>
                  <div
                    class="arrow"
                    :class="{
                      ['arrowOpen']: isOpenSubMenu && activeMenu == 'cognition',
                    }"
                  >
                    <span>></span>
                  </div>
                </div>

                <ul
                  class="m-sub-menu"
                  v-if="isOpenSubMenu && activeMenu == 'cognition'"
                >
                  <li class="sub-menu-title">
                    <router-link to="/cognition/">
                      <span>기능성 게임</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/cognition/multigame">
                      <span>멀티 게임</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/cognition/cognition">
                      <span>인지 평가 게임</span>
                    </router-link>
                  </li>
                  <!-- <li class="sub-menu-title">
                    <router-link to="/cognition/story">
                      <span>스토리 웹툰</span>
                    </router-link>
                  </li> -->
                </ul>
              </li>

              <li class="item">
                <div class="main-menu" @click="dropdownIsOpenClose('news')">
                  <router-link
                    to="/news"
                    :class="{menuActive: isActive('news')}"
                  >
                    <span class="tab-title">소식</span>
                  </router-link>
                  <div
                    class="arrow"
                    :class="{
                      ['arrowOpen']: isOpenSubMenu && activeMenu == 'news',
                    }"
                  >
                    <span>&gt;</span>
                  </div>
                </div>

                <ul
                  class="m-sub-menu"
                  v-if="isOpenSubMenu && activeMenu == 'news'"
                >
                  <li class="sub-menu-title">
                    <router-link to="/news">
                      <span>공지 사항</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/news/reference">
                      <span>설치 사례</span>
                    </router-link>
                  </li>
                  <li class="sub-menu-title">
                    <router-link to="/news/faq">
                      <span>FAQ</span>
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </article>
      </section>
    </section>
  </div>
</template>

<script>
import items from "../assets/source/json/menu.json";
export default {
  data() {
    return {
      pages: items,

      isMenuClose: false,
      gameIndex: 0,
      naviIsOpenToClose: false,
      isOpen: false,
      isOpenSubMenu: false,
      activeMenu: "",
    };
  },

  computed: {},
  created() {
    this.check_mobile();
  },
  mounted() {
    window.addEventListener("resize", this.check_mobile);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.check_mobile);
  },
  watch: {
    $route() {
      this.naviIsOpenToClose = false;
    },
  },

  methods: {
    isActive(menuName) {
      if (menuName === this.$route.path.split("/")[1]) {
        return true;
      } else {
        return false;
      }
    },
    doMouseOver() {
      this.is_active = true;
    },

    mouseFocusOut() {
      this.is_active = false;
    },

    clickMenu(menuName, index) {
      if (
        menuName === this.$route.name &&
        index === parseInt(this.$route.query.index)
      ) {
        return;
      }
      this.$router.push({
        name: menuName,
        query: {index: index},
      });
    },

    doMouseLeave: function() {
      if (window.innerWidth > 1024) {
        this.is_true = false;
        this.is_active = false;
      }
    },
    check_mobile() {
      if (window.innerWidth <= 1024) {
        this.is_mobile = true;
      } else {
        this.is_mobile = false;
      }
    },
    check_menu_kind(menu_kind, main_menu) {
      if (window.innerWidth < 1024) {
        this.is_active = true;
        this.is_true = true;
        return true;
      } else {
        if (menu_kind == main_menu) {
          return true;
        } else {
          return false;
        }
      }
    },

    naviIsOpen() {
      this.naviIsOpenToClose = true;
    },

    dropdownIsOpenClose(menuName) {
      this.activeMenu = menuName;

      this.isOpenSubMenu = !this.isOpenSubMenu;
    },
  },
};
</script>

<style scoped>
.menuActive {
  color: #f83f1b !important;
  border-bottom: none !important;
}

* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
  display: block;
}
a:visited {
  color: black;
}
.d_none {
  display: none;
}
.d_block {
  display: block;
}
.mobile.d_none {
  display: block;
}
ul.active {
  /* border: 1px solid #333333; */
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  /* border-radius: 20px; */
  position: absolute;
  margin: 0 1rem;
  padding: 0.5rem 0;
}

.active {
  z-index: 100;
}
.tab-title.router-link-active {
  color: #dc375d !important;
}
.router-link-active span.main_menu {
  /* 상위 경로일 때 하이라이트 처리 */
  color: #dc375d !important;
  padding: 4px 0;
  border-bottom: 2px solid #dc375d !important;
}
a.logo {
  display: flex;
  align-items: center;
}
a.imgWrap img {
  width: 100%;
}
.m-nav_main {
  position: fixed;
  flex-flow: row nowrap;
  width: 100vw;
  top: 0;
  z-index: 99999;
  background: white;
  border-bottom: 1px solid #dddddd;
  height: 71px;
}
.navigation {
  justify-content: space-between;
  margin: 0 auto;
  align-items: center;
  height: 71px;
}
.m-menu-icon {
  align-items: center;
  height: 71px;
}
.drop-down {
  top: 0;
  position: absolute;
  width: 100%;
}

.main-list {
  background-color: #ffffff;
  height: 100vh;
}

.sns-icon-close {
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
}

.main-menu {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  /* padding: 2.5rem 1rem; */
}

.m-sub-menu {
  border-top: 1px solid #dddddd;
  background-color: #f9f9f9;
  display: flex;
  text-align: left;
  padding: 0 1rem;
  /* padding: 2.5rem 1rem; */
}
.sub-menu-title {
  width: 50%;
}
.m-sub-menu span {
  font-size: 1rem;
  color: #545454;
}
.arrow {
  width: 20px;
  transform: rotate(-270deg);
  text-align: center;
}
.arrow span {
  color: #0a0a0a;
  font-size: 20px;
}
.arrowOpen {
  margin-left: auto;
  transform: rotate(-90deg);
}

.icon {
  display: flex;
  /* padding: 0 1rem 3rem 2rem; */
}

.instagram-icon,
.facebook-icon,
.kakao-icon {
  padding-right: 0.5rem;
}

.main-list .main-list__title {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  width: 100%;
  text-align: left;
}

.main-list .main-list__title .item {
  width: 100%;
  vertical-align: middle;
  cursor: pointer;
  line-height: 8vh;
  font-size: 1.2rem;
  color: #545454;
  border-bottom: 1px solid #afafaf;
}
/* .item a {
  display: block;
} */

.main-list .main-list__title .item:hover {
  color: #f77e0b;
}

.item:hover .dropdown-menu {
  display: block;
}

.m-menu-icon {
  display: flex;
  justify-content: space-between;
}

.right {
  display: flex;
}
.icon {
  display: flex;
  align-items: center;
}
.logo {
  display: inline-block;
}

.instagram-icon,
.facebook-icon {
  margin-right: 0.5rem;
  width: 45px;
  height: 45px;
}
.kakao-icon {
  width: 45px;
  height: 45px;
}
.icon img {
  width: 100%;
  display: block;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  -ms-interpolation-mode: nearest-neighbor;
  image-rendering: crisp-edges;
}
.dropdown-menu.active {
  display: block;
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  display: none;
  background-color: #ffffff;
  border-bottom: 1px solid #e6e6e6;
  /* padding: 0 2rem 1.5rem 2rem; */
}
.dropdown-menu .menu-background {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: right;
}

.dropdown-menu .menu-background .sub-menu {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.sub-menu a {
  margin-bottom: 0.8rem;
  cursor: pointer;
}

.router-link-exact-active {
  color: #f77e0b;
  font-weight: 600;
}

.sub-menu {
  padding: 1rem 0 3rem;
}

.sub-menu.last-menu {
  width: 10.4rem;
}
.sub-menu.table {
  margin: 0 2.7rem 0 2.9rem;
}
.sub-menu.game {
  margin: 0 2rem;
}

.sub-menu.game-story {
  margin-left: 3.2rem;
}

.sub-menu.news {
  margin-left: 3.1rem;
}
.m-sub-menu .router-link-exact-active {
  text-decoration: underline 3px;
  text-underline-offset: 8px;
}

.title {
  color: #545454;
}
#nav a.router-link-exact-active span {
  color: #f83f1b !important;
}
</style>
